import React, { useEffect, useState } from 'react';
import './SessionTimer.css';

interface SessionTimerProps {
  /** Epoch ms when the session ends, or null if unknown. */
  endsAt: number | null;
  /**
   * Overrides the wall clock. Replay runs on a virtual clock set to the original
   * recording's epoch time, so the countdown has to be measured against that.
   */
  now?: number;
}

function formatRemaining(ms: number): string {
  const clamped = Math.max(0, ms);
  const totalSeconds = Math.floor(clamped / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export const SessionTimer: React.FC<SessionTimerProps> = ({
  endsAt,
  now: nowOverride,
}) => {
  const [tick, setTick] = useState(() => Date.now());

  useEffect(() => {
    if (endsAt == null || nowOverride != null) return;
    const id = setInterval(() => setTick(Date.now()), 1000);
    return () => clearInterval(id);
  }, [endsAt, nowOverride]);

  if (endsAt == null) return null;

  const remaining = endsAt - (nowOverride ?? tick);
  const finished = remaining <= 0;

  return (
    <div className={`session-timer${finished ? ' session-timer--finished' : ''}`}>
      <span className="session-timer-label">Time left</span>
      <span className="session-timer-value">
        {finished ? 'FINISHED' : formatRemaining(remaining)}
      </span>
    </div>
  );
};

export default SessionTimer;
